import { useSelector } from 'react-redux';

export const useBackgroundColor = () => {
  const currentColor = useSelector(({ scene: { config: { currentBackground } } }) => (currentBackground && currentBackground.value));
  return currentColor;
};

export default useBackgroundColor;
